export const LOADING = '/loading';
export const LOGIN = '/login';
export const FORGOT_PASSWORD_EMAIL = '/forgot_password/email_confirm';
export const FORGOT_PASSWORD_RESET = '/forgot_password/reset';
export const REGISTER_CREDENTIALS = '/register/credentials';
export const REGISTER_EMAIL_CONFIRM = '/register/email_confirm';
export const REGISTER_CREATE_PROFILE = '/register/create_profile';
export const NO_CADDIE_MASTERS = '/register/awaiting_approval';
export const PLATFORM_HOME = '/';
export const DASHBOARD = '/dashboard';
export const EXPLORER = '/explorer';

export const buildUrl = (url: string): string => {
    return "/platform" + url
}